export const getCategories = (t) => [
  {
    id: 1,
    name: t("categories.canvasWallArt"),
    imageSrc: "/images/categories/canvas.png",
    to: "/wallarts",
  },
  {
    id: 2,
    name: t("categories.fridgeHealthProducts"),
    imageSrc: "/images/categories/fridge.png",
    to: "/fridgeDeo",
  },
  {
    id: 3,
    name: t("categories.handmadeProducts"),
    imageSrc: "/images/categories/hm.png",
    to: "/handmadeProducts",
  },
  {
    id: 4,
    name: t("categories.homeAndKitchen"),
    imageSrc: "/images/categories/kitchen.png",
    to: "/kitchenProducts",
  },
  {
    id: 5,
    name: t("categories.naturalProducts"),
    imageSrc: "/images/categories/natural.png",
    to: "/naturalProducts",
  },
  {
    id: 6,
    name: t("categories.giftsAndPackages"),
    imageSrc: "/images/categories/gift.png",
    to: "/giftProducts",
  },
  {
    id: 7,
    name: t("categories.campingAndOutdoors"),
    imageSrc: "/images/categories/camp.png",
    to: "/campingOutdoors",
  },
  {
    id: 8,
    name: t("categories.naturalTherapy"),
    imageSrc: "/images/categories/therapy.png",
    to: "/wheatbag",
  },
];
